import { MultiSelect } from '@/components/ui/multi-select'

interface ChipMultiSelectProps {
  chipDisplay?: 'chip' | 'comma'
  single?: boolean
  options?: unknown[]
  value?: unknown
  onChange?: (e: { value: unknown }) => void
  optionLabel?: string
  optionValue?: string
  placeholder?: string
  filter?: boolean
  className?: string
  disabled?: boolean
  style?: React.CSSProperties
}

export function ChipMultiSelect({
  chipDisplay = 'chip',
  single,
  options = [],
  value,
  onChange,
  optionLabel = 'label',
  optionValue = 'value',
  placeholder,
  className,
  disabled,
}: ChipMultiSelectProps) {
  // Normalize options to { label, value } format
  const normalizedOptions = (options as Record<string, unknown>[]).map((opt) => ({
    label: String(opt[optionLabel] ?? opt),
    value: String(opt[optionValue] ?? opt),
  }))

  // Normalize value to string[]
  const normalizedValue: string[] = single
    ? (value ? [String(value)] : [])
    : (Array.isArray(value) ? value.map(String) : [])

  const handleChange = (newValue: string[]) => {
    if (!onChange) return
    if (single) {
      // For single mode, take the last selected item
      const lastItem = newValue[newValue.length - 1] ?? null
      onChange({ value: lastItem })
    } else {
      onChange({ value: newValue })
    }
  }

  return (
    <MultiSelect
      options={normalizedOptions}
      value={normalizedValue}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      selectionLimit={single ? 1 : undefined}
      display={chipDisplay}
    />
  )
}
